// actions.js
export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_TICKETS_REQUEST = 'FETCH_USER_TICKETS_REQUEST';
export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';

export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_TICKETS_SUCCESS = 'FETCH_USER_TICKETS_SUCCESS';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';

export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const FETCH_USER_TICKETS_FAILURE = 'FETCH_USER_TICKETS_FAILURE';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

export const createUserRequest = (data) => ({ type: CREATE_USER_REQUEST, payload: data });
export const fetchUsersRequest = (data) => ({ type: FETCH_USERS_REQUEST, payload: data });
export const fetchUserRequest = (data) => ({ type: FETCH_USER_REQUEST, payload: data });
export const fetchUserTicketsRequest = (data) => ({ type: FETCH_USER_TICKETS_REQUEST, payload: data });
export const updateUserRequest = (data) => ({ type: UPDATE_USER_REQUEST, payload: data });
export const deleteUserRequest = (data) => ({ type: DELETE_USER_REQUEST, payload: data });
export const changePasswordRequest = (data) => ({ type: CHANGE_PASSWORD_REQUEST, payload: data });

export const createUserSuccess = (data) => ({ type: CREATE_USER_SUCCESS, payload: data });
export const fetchUsersSuccess = (data) => ({ type: FETCH_USERS_SUCCESS, payload: data });
export const fetchUserSuccess = (data) => ({ type: FETCH_USER_SUCCESS, payload: data });
export const fetchUserTicketsSuccess = (data) => ({ type: FETCH_USER_TICKETS_SUCCESS, payload: data });
export const updateUserSuccess = (data) => ({ type: UPDATE_USER_SUCCESS, payload: data });
export const deleteUserSuccess = (data) => ({ type: DELETE_USER_SUCCESS, payload: data });
export const changePasswordSuccess = (data) => ({ type: CHANGE_PASSWORD_SUCCESS, payload: data });

export const createUserFailure = (error) => ({ type: CREATE_USER_FAILURE, payload: error });
export const fetchUsersFailure = (error) => ({ type: FETCH_USERS_FAILURE, payload: error });
export const fetchUserFailure = (error) => ({ type: FETCH_USER_FAILURE, payload: error });
export const fetchUserTicketsFailure = (error) => ({ type: FETCH_USER_TICKETS_FAILURE, payload: error });
export const updateUserFailure = (error) => ({ type: UPDATE_USER_FAILURE, payload: error });
export const deleteUserFailure = (error) => ({ type: DELETE_USER_FAILURE, payload: error });
export const changePasswordFailure = (error) => ({ type: CHANGE_PASSWORD_FAILURE, payload: error });